export const CreditActionTypes = {
  START_CHECKOUT_SESSION: '@@credit/START_CHECKOUT_SESSION',
  START_CHECKOUT_SESSION_FAILURE: '@@credit/START_CHECKOUT_SESSION_FAILURE',
}

export interface IStartCheckoutSessionPayload {
  readonly hours: number
  readonly accountId: number
}
